/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many grams are in an ounce?`)
};

const es_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos gramos hay en una onza?`)
};

const de_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Gramm hat eine Unze?`)
};

const nl_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel gram zitten in een ounce?`)
};

const fr_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de grammes sont dans une once ?`)
};

const it_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti grammi ci sono in un'oncia?`)
};

const pt_br2_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos gramas tem em uma onça?`)
};

const pt_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos gramas existem numa onça?`)
};

const ja_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1オンスには何グラムありますか?`)
};

const zh_uc_wt_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq3_q", locale)
	if (locale === "en") return en_uc_wt_faq3_q(inputs)
	if (locale === "es") return es_uc_wt_faq3_q(inputs)
	if (locale === "de") return de_uc_wt_faq3_q(inputs)
	if (locale === "nl") return nl_uc_wt_faq3_q(inputs)
	if (locale === "fr") return fr_uc_wt_faq3_q(inputs)
	if (locale === "it") return it_uc_wt_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq3_q(inputs)
	if (locale === "pt") return pt_uc_wt_faq3_q(inputs)
	if (locale === "ja") return ja_uc_wt_faq3_q(inputs)
	return zh_uc_wt_faq3_q(inputs)
};